import useCommercesAutocomplete from '../../Shippings/hooks/useCommercesAutocomplete';
import { useGetCommerceByIdQuery } from '../../Commerce/services/commerces.service';
import { Option } from '@/components/inputs/AutocompleteInput';
import { useEffect, useMemo, useState } from 'react';

interface UseCommerceSearchInputProps {
  commerceId?: string;
}

const useCommerceSearchInput = ({ commerceId }: UseCommerceSearchInputProps) => {
  const [selectedCommerce, setSelectedCommerce] = useState<Option | null>(null);
  const [commerceSearch, setCommerceSearch] = useState('');

  const { commerceOptions, isCommercesLoading } = useCommercesAutocomplete({
    search: commerceSearch,
  });

  const commerceIdForLookup = commerceId?.trim() ?? '';

  const { data: commerceDetails } = useGetCommerceByIdQuery(
    { commerceId: commerceIdForLookup },
    {
      skip:
        !commerceIdForLookup ||
        (!!selectedCommerce && selectedCommerce.data === commerceIdForLookup),
    }
  );

  const resolvedSelectedCommerce = useMemo((): Option | null => {
    if (!commerceIdForLookup) return selectedCommerce;
    if (selectedCommerce && selectedCommerce.data === commerceIdForLookup)
      return selectedCommerce;
    if (commerceDetails) {
      return {
        label: commerceDetails.name?.trim() || commerceIdForLookup,
        data: commerceIdForLookup,
      };
    }
    return null;
  }, [commerceIdForLookup, commerceDetails, selectedCommerce]);

  useEffect(() => {
    if (!commerceId) setSelectedCommerce(null);
  }, [commerceId]);

  const handleCommerceSelect = (option: Option | null) => {
    setSelectedCommerce(option);
  };

  const clearCommerce = () => {
    setCommerceSearch('');
    setSelectedCommerce(null);
  };

  return {
    resolvedSelectedCommerce,
    commerceSearch,
    setCommerceSearch,
    commerceOptions,
    isCommercesLoading,
    handleCommerceSelect,
    clearCommerce,
  };
};

export default useCommerceSearchInput;
